module.exports = __webpack_public_path__ + "assets/img/modal-avatar-6d2c0001.png";